import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const PlaygroundTabs = ({ tabs, activeTab, onTabChange }) => {
  const [hoveredTab, setHoveredTab] = useState(null);

  return (
    <div className="border-b border-border bg-background">
      <div className="flex items-center space-x-1 px-6 overflow-x-auto">
        {tabs?.map((tab) => (
          <button
            key={tab?.id}
            onClick={() => onTabChange(tab?.id)}
            onMouseEnter={() => setHoveredTab(tab?.id)}
            onMouseLeave={() => setHoveredTab(null)}
            className={`flex items-center space-x-2 px-4 py-3 text-sm font-medium border-b-2 transition-all duration-300 whitespace-nowrap ${
              activeTab === tab?.id
                ? 'border-accent text-accent bg-accent/5' :'border-transparent text-text-secondary hover:text-primary hover:border-border'
            }`}
          >
            <Icon 
              name={tab?.icon} 
              size={16} 
              className={`transition-colors duration-300 ${
                activeTab === tab?.id ? 'text-accent' : ''
              }`}
            />
            <span>{tab?.label}</span>
            {tab?.badge && (
              <span className={`px-2 py-0.5 text-xs rounded-full ${
                activeTab === tab?.id
                  ? 'bg-accent text-accent-foreground'
                  : 'bg-muted text-text-secondary'
              }`}>
                {tab?.badge}
              </span>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default PlaygroundTabs;